/* @flow */
import idx from 'idx';
import * as React from 'react';
import { graphql } from 'react-apollo';
import GET_ADMIN_INTEGRATION from 'admin/queries/getAdminIntegration.gql';
import UPSERT_ADMIN_INTEGRATION from 'admin/queries/upsertAdminIntegration.gql';

type Props = {
  data: *,
  children: Function,
  providerKey: string,
  organizationUUID: string,
  upsertAdminIntegration: Function,
};

type UpsertInput = {
  config?: {
    clientID: string,
    clientSecret: string,
    installationURLDomain: string,
  },
  enabledByOrg: boolean,
};

class ACIContainer extends React.Component<Props, {}> {
  upsert = (input: UpsertInput) => {
    return this.props.upsertAdminIntegration({
      variables: {
        organizationUUID: this.props.organizationUUID,
        providerKey: this.props.providerKey,
        input,
      },
    });
  };

  render() {
    return this.props.children({
      upsert: this.upsert,
      integration: idx(this.props, _ => _.data.adminPossibleIntegration),
    });
  }
}

const withAdminIntegration = graphql(GET_ADMIN_INTEGRATION, {
  options: ({ organizationUUID, providerKey }) => ({
    variables: { organizationUUID, providerKey },
  }),
});

const withUpsertAdminIntegration = graphql(UPSERT_ADMIN_INTEGRATION, {
  name: 'upsertAdminIntegration',
});

export default withAdminIntegration(withUpsertAdminIntegration(ACIContainer));
